import VipCorner from '@/assets/images/vip/vip_corner.png';

interface VipCardProps {
  name: string;
  money: number;
  corner?: string;
  isSelected: boolean;
  className?: string; // 添加 className 属性
  onClick: () => void;
}

const VipCard: React.FC<VipCardProps> = ({ name, money, corner, isSelected, className, onClick }) => {
  return (
    <div
      className={`relative flex flex-col items-center justify-center pt-[28px] pr-[24px] pb-[24px] pl-[24px] rounded-[16px] border-[1px] cursor-pointer transition-colors duration-50 ${isSelected ? 'bg-[#FFD642] border-[#FF8F3F]' : 'bg-white border-white'
        }  ${className}`}
      onClick={onClick}
    >
      {corner && (<>
        <img alt='' src={VipCorner} className='absolute top-[-1.5px] left-[-1.5px] w-[50px] h-[20px]' />
        <div className="absolute top-[-1.5px] left-[-1.5px] w-[50px] h-[20px] text-center leading-[20px] text-[#fff] text-[11px] font-normal">{corner}</div>
      </>)}

      <div className="text-[#393939] text-[16px] font-medium leading-[16px]">{name}</div>
      <div className='flex flex-row items-end justify-between mt-[4px]'>
        <div className={`font-medium text-[#393939] text-[20px] leading-[20px] mr-[3px] mb-[3px]`}>¥</div>
        <div className={`font-medium text-[#393939] text-[34px] leading-[34px]`}>{money / 100}</div>
      </div>
    </div>
  );
};
export default VipCard;